import { render } from "./OrdersTable.vue?vue&type=template&id=77018a4e"
import script from "./OrdersTable.vue?vue&type=script&lang=js"
export * from "./OrdersTable.vue?vue&type=script&lang=js"

import "./OrdersTable.vue?vue&type=style&index=0&id=77018a4e&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Itineraries/OrdersTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77018a4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77018a4e', __exports__)) {
    console.log('reload')
    api.reload('77018a4e', __exports__)
  }
  
  module.hot.accept("./OrdersTable.vue?vue&type=template&id=77018a4e", () => {
    console.log('re-render')
    api.rerender('77018a4e', render)
  })

}


export default __exports__